import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import moment from 'moment';
import 'moment/locale/fr';

import ErrorComponent from '../../components/Error';

import '../../utils/styles/News.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

import { useApi } from '../../utils/hooks';

function NewsDetails() {
    const { newsId } = useParams();
    const navigate = useNavigate();

    const { data, loading, error } = useApi(`news/${newsId}`);

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    // Format the date to a more readable format
    moment.locale('fr');
    const formatDate = moment(data.timestamp).format('DD MMMM YYYY');

    return (
        <div id="news-details">
            <div>
                <a href={data.img}>
                    <img id='news-details-img' src={data.img} alt="l'actualité" />
                </a>
                <button
                    onClick={() => {
                        navigate(-1);
                    }}
                    className="circle news-back"
                >
                    <FontAwesomeIcon icon={faChevronLeft} size="xl" />
                </button>
            </div>

            <div className="container">
                <p className="title">{data.title}</p>
                <div className="news-info-details">
                    <p>{formatDate}</p>
                    <p>par {data.author}</p>
                </div>

                {/* Display the news content and sanitize it */}
                {/* The content is sanitized to prevent XSS attacks!!!! */}
                <div
                    id="news-details-description"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(data.content),
                    }}
                ></div>
            </div>
        </div>
    );
}

export default NewsDetails;
